import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchApi } from '../utils/fetchApi';
import { hashPassword } from '../utils/helpers';
import { useUser } from '../context/userContext';

export const PasswordChange: React.FC = () => {
  const { t } = useTranslation();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [passwordValid, setPasswordValid] = useState(false);

  const isPasswordStrong = (password: string) => {
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const isLongEnough = password.length >= 8;
    return hasUppercase && hasLowercase && hasNumber && isLongEnough;
  };

  useEffect(() => {
    setPasswordValid(isPasswordStrong(newPassword));
  }, [newPassword]);

  const { updatePassword } = useUser();

  const handleSave = async () => {
    setError('');

    if (newPassword !== confirmPassword) {
      setError(t('passwordsDoNotMatch'));
      return;
    }

    if (!passwordValid) {
      setError(t('passwordTooWeak'));
      return;
    }

    const username = localStorage.getItem('username');
    if (!username) {
      setError(t('missingUsername'));
      return;
    }

    const pwhash = await hashPassword(newPassword);

    try {
      await fetchApi('change_password', {
        new_pwhash: pwhash,
      });

      await updatePassword(username, newPassword);

      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(t('passwordChangeFailed'));
      console.error(err);
    }
  };

  return (
    <div className="passwordChange">
      <h2>{t('changePassword')}</h2>

      {/* <label>
        {t('currentPassword')}
        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
      </label> */}

      <label>
        {t('newPassword')}
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className={newPassword !== "" ? (passwordValid ? "valid" : "invalid") : ""}
        />
        {
          newPassword !== "" && (
            <small className={passwordValid ? "validText" : "invalidText"}>
              {passwordValid ? t('passwordStrong') : t('passwordRequirement')}
            </small>
          )
        }
      </label>

      <label>
        {t('confirmPassword')}
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </label>

      {error && <p className="error">{error}</p>}

      <button className="button" onClick={handleSave}>
        {t('save')}
      </button>
    </div>
  );
};
